export const formationDateFormat = (params) => {
    const date = new Date(params);

    const opciones = {
        day: "numeric",
        month: "long",
        year: "numeric"
    };

    let f = date.toLocaleDateString("es-ES", opciones);

    f = f.replace(" de 2025", " 2025");

    return f
};

